module.exports = __webpack_public_path__ + "static/media/online-shopping-discount.be7d4715.png";